var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C5.85467 0 3.27461 2.42023 3.02054 5.5H3V13C3 14.1046 2.10457 15 1 15H0V17H6C6 17.394 6.0776 17.7841 6.22836 18.1481C6.37913 18.512 6.6001 18.8427 6.87868 19.1213C7.15726 19.3999 7.48797 19.6209 7.85195 19.7716C8.21593 19.9224 8.60603 20 9 20C9.39397 20 9.78407 19.9224 10.1481 19.7716C10.512 19.6209 10.8427 19.3999 11.1213 19.1213C11.3999 18.8427 11.6209 18.512 11.7716 18.1481C11.9224 17.7841 12 17.394 12 17H18V15H17C15.8954 15 15 14.1046 15 13V5.5H14.9795C14.7254 2.42023 12.1453 0 9 0ZM12.9862 5.66444C12.9896 5.70542 12.9942 5.74604 13 5.78624V13C13 13.7286 13.1948 14.4117 13.5351 15H4.46487C4.80521 14.4117 5 13.7286 5 13V5.78624C5.00578 5.74604 5.01038 5.70542 5.01377 5.66444C5.18298 3.61334 6.90411 2 9 2C11.0959 2 12.817 3.61334 12.9862 5.66444ZM10 17H8C8 17.1313 8.02587 17.2614 8.07612 17.3827C8.12638 17.504 8.20004 17.6142 8.29289 17.7071C8.38575 17.8 8.49599 17.8736 8.61732 17.9239C8.73864 17.9741 8.86868 18 9 18C9.13132 18 9.26136 17.9741 9.38268 17.9239C9.50401 17.8736 9.61425 17.8 9.70711 17.7071C9.79996 17.6142 9.87362 17.504 9.92388 17.3827C9.97413 17.2614 10 17.1313 10 17Z",
    fill: "#4C96FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.c8f10ebd0cf577145a3936b1c65895b6.svg";
export { ForwardRef as ReactComponent };